// extracted by css-extract-rspack-plugin
export default {"container":"_ee20ea9a","imageContainer":"_e9f450bd","image":"_c46d9cfa","heading":"_84aa6f15","subHeading":"_76388271","fullWidth":"_6e1e7b48"};